import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';

import Modal from 'components/Modal';
import { numberUnmask } from 'utils/unmasks';
import imgError from 'assets/images/error.svg';
import ApplicationId from 'components/ApplicationId';
import {
  newNextAction,
  NEW_NEXT,
} from '../../actions/navigation';
import { useConfig } from '../../config/ConfigContext';
import Header from '../../components/Header';
import Tooltip from '../../components/Tooltip';
import Input from '../../components/Form/Input';
import Validator from '../../components/Validator';
import Progress from '../../components/Progress';
import Button from '../../components/Button';
import schema from './continueSchema';

const Continue = (props) => {
  const config = useConfig();
  const { validator: { values, errors }, checkinData, params, searchParams } = props;
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [uploadingPercentage, setUploadingPercentage] = useState(null);
  const workflowType = get(params, 'workflowType');
  const key = searchParams.get('key');
  const to = searchParams.get('to');

  useEffect(() => {
    const { navigate } = props;

    if (get(checkinData, ['data', 'data']) === undefined) {
      if (to) {
        navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}&to=${to}`);
      } else {
        navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}`);
      }
    }
  }, []);

  useEffect(() => {
    const { fetch, navigate } = props;

    if (fetch.isDone[`${NEW_NEXT}`] && !fetch.isRunning[`${NEW_NEXT}`]) {
      const routeUrl = checkinData.data && checkinData.data.url.replace(config.hostUrl, '');
      navigate(routeUrl);
    }
  }, [checkinData]);

  const handleSubmitForm = (e) => {
    e.preventDefault();
    const { dispatch, validator: { validate } } = props;
    if (validate(schema).isValid) {
      let formData;
      if (to) {
        formData = {
          SsnLast4Digits: numberUnmask(values.ssn),
          to,
        };
      } else {
        formData = {
          SsnLast4Digits: numberUnmask(values.ssn),
        };
      }
      setIsProgressVisible(true);

      dispatch(newNextAction({
        key,
        workflowType: workflowType || 'text2apply',
        data: formData,
        onUploadProgress: (progressEvent) => {
          setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
        },
        fail: (err) => {
          console.log(err);
          setIsPopupVisible(true);
          setIsProgressVisible(false);
        },
      }));
    } else {
      console.log(errors);
      setIsPopupVisible(true);
      setIsProgressVisible(false);
    }
  };

  const handleInputChange = (event) => {
    const { validator: { onChangeHandler } } = props;
    onChangeHandler(event.target.name, event.target.value);
  };

  const handleClosePopup = () => {
    setIsPopupVisible(false);
  };

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      <ApplicationId id={get(checkinData, 'attributes.entityId')} inHeadline />
      <div className="content appIdVisible">
        <h2>
          Welcome back,
          {' '}
          {get(checkinData, 'data.data.firstName')}
          !
        </h2>
        <h1>
          Congratulations!
          {' '}
          <br />
          You’re Pre-Approved
        </h1>
        <p>On the next screen you’ll review your options and select your loan</p>
        <p>Before reviewing your options please enter the last 4 of your SSN to verify your identity</p>
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="form-group active">
                <Input
                  label="Last 4 Digits of Your SSN"
                  value={values.ssn || ''}
                  name="ssn"
                  tooltip="To protect your identity and for security purposes please enter the last 4 digits of your Social Security Number."
                  isMasked={[/\d/, /\d/, /\d/, /\d/]}
                  onChange={handleInputChange}
                  type="tel"
                  isRequired
                  hasError={errors.ssn}
                />
                <Tooltip>To protect your identity and for security purposes please enter the last 4 digits of your Social Security Number.</Tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="row">
          <div className="col">
            <Button
              className="btn btn-primary arrow"
              onClick={handleSubmitForm}
              title="Continue"
              isDisabled={values.ssn === undefined}
            />
          </div>
        </div>
      </div>
      {
        isPopupVisible
          && (
          <Modal>
            <div className="card-content error-modal security-error">
              <img src={imgError} alt="" />
              <p>Please try again.</p>
              <div onClick={handleClosePopup} className="btn btn-red">OK</div>
            </div>
          </Modal>
          )
      }
      {
        isProgressVisible && <Progress percent={uploadingPercentage} />
      }
    </div>
  );
};

Continue.propTypes = {
  navigate: PropTypes.func.isRequired,
  validator: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  fetch: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default Validator(schema)(connect(mapStateToProps)(Continue));
